module.exports = __webpack_public_path__ + "static/media/Kaltexsj.79f80157.jpg";